import { jsx } from "react/jsx-runtime";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { validateTidalLicense } from "../../base/index.js";
function TextSnippet(props) {
  return /* @__PURE__ */ jsx(
    TextSnippetIcon,
    {
      "data-testid": "TextSnippet",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TextSnippet",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
TextSnippet.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "TextSnippet"
};
validateTidalLicense();
export {
  TextSnippet
};
//# sourceMappingURL=TextSnippet.js.map
